import ActionButtons from "./Sections/ActionButtons/ActionButtons";
import AppName from "./Sections/AppName/AppName";
import AutoLayout from "../../../AutoLayout/AutoLayout";
import LogoImage from "./Sections/LogoImage/LogoImage";
import MenuButton from "./Sections/MenuButton/MenuButton";
import { useIsRequestQueueRoute } from "../../../../../../Routes/useIsRequestQueueRoute";
import React from "react";
import styled from "styled-components";
import {
  AutoLayoutAlignEnum,
  AutoLayoutDirectionEnum,
  AutoLayoutResizingEnum,
} from "../../../AutoLayout/AutoLayoutEnums";
import { FontSizeEnum } from "../../../../FontText/FontTextEnums";
import { ITheme } from "../../../../Themes/ThemeTypes";
import { ThemeColorEnum } from "../../../../Themes/ThemeEnums";
import { useIsMobile } from "../../IsMobileHook";

const ResponsiveAutoLayout = styled(AutoLayout)<{ theme: ITheme }>`
  @media (max-width: ${(props) => props.theme.base.responsive.mobile}px) {
    justify-content: center;
  }
`;

interface AppHeaderProps {
  children: React.ReactNode;
  isLeftNavButtonVisible: boolean;
  appLogoPath?: string;
  logo?: React.ReactNode;
  appName: string;
}

const AppHeader: React.FC<AppHeaderProps> = ({
  children,
  isLeftNavButtonVisible,
  appLogoPath,
  logo,
  appName,
}) => {
  const isRequestQueue = useIsRequestQueueRoute();
  const isMobile = useIsMobile();

  return (
    <AutoLayout
      $height={64}
      $horizontalResizing={AutoLayoutResizingEnum.FILL}
      $verticalResizing={AutoLayoutResizingEnum.FIXED}
      $backgroundColor={isMobile ? ThemeColorEnum.SURFACE : ThemeColorEnum.SURFACE_VARIANT}
      $align={AutoLayoutAlignEnum.LEFT}
      $leftRightPadding={16}
    >
      {isLeftNavButtonVisible && !isRequestQueue && <MenuButton />}

      <ResponsiveAutoLayout
        $direction={AutoLayoutDirectionEnum.HORIZONTAL}
        $align={AutoLayoutAlignEnum.LEFT}
        $horizontalResizing={AutoLayoutResizingEnum.FILL}
        $gap={4}
      >
        {logo ?? (appLogoPath ? <LogoImage appLogoPath={appLogoPath} appName={appName} /> : null)}
        <AppName appName={appName} fontSize={FontSizeEnum.LARGE} />
      </ResponsiveAutoLayout>

      <ActionButtons>{children}</ActionButtons>
    </AutoLayout>
  );
};

export default AppHeader;
